/* Local calendar validation and explicit Temporal disambiguation. No offset guessing. */
(() => {
  'use strict';
  const root = typeof window === 'undefined' ? globalThis : window;
  const temporal = () => { if (!root.temporal?.Temporal) throw Error('timezone_dependency'); return root.temporal.Temporal; };
  function date(value, now = Date.now()) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw Error('date');
    let result;
    try { result = temporal().PlainDate.from(value, {overflow:'reject'}); }
    catch(error) { if(error.message==='timezone_dependency')throw error;throw Error('date'); }
    const latest = new Date(now + 14*3600000).toISOString().slice(0,10);
    if (result.year < 1900 || value > latest) throw Error('date_range');
    return result;
  }
  function resolve(day, time, zone, now = Date.now()) {
    const d = date(day,now);
    // GeoNames modern city zones cannot establish reliable pre-1970 local history.
    if (d.year < 1970) return {status:'historical', candidates:[]};
    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) throw Error('time');
    if (typeof zone !== 'string' || !/^[A-Za-z_]+\/[A-Za-z0-9_+\-/]+$/.test(zone)) throw Error('zone');
    const T=temporal(), local=T.PlainDateTime.from(`${day}T${time}:00`);
    let a,b;
    try { a=local.toZonedDateTime(zone,{disambiguation:'earlier'}); b=local.toZonedDateTime(zone,{disambiguation:'later'}); }
    catch { throw Error('zone'); }
    // Gaps are shifted by Temporal; reject rather than silently adopting that shift.
    const candidates=[a,b].filter(z=>z.toPlainDateTime().equals(local)).filter((z,i,list)=>list.findIndex(x=>x.epochMilliseconds===z.epochMilliseconds)===i).map(z=>({utc:z.toInstant().toString(),time:z.epochMilliseconds,offset:z.offset}));
    if (!candidates.length) return {status:'gap',candidates};
    if (candidates.some(z=>z.time > now)) return {status:'future',candidates:[]};
    return {status:candidates.length===2?'ambiguous':'ready',candidates};
  }
  root.MoonmeetTimezones=Object.freeze({date,resolve});
})();
